const ImageO2TVLink = 'https://cdn.o2.cz/mojeo2-product/mo2product_picture/CP-o2tv.png';

export default ImageO2TVLink;
